import Collection from '$dependencies/Collection';
import PhotoModel, { extractPhotoList, normalizePhoto } from '$models/PhotoModel';

export default class PhotoCollection extends Collection {
	constructor(args = {}) {
		args = Object.assign({}, args);
		args.Model = PhotoModel;
		super(args);
	}

	post() {
		return this._models.reduce((chain, model) => chain.then(() => {
			if (this.config.headers) {
				model.setConfig('headers', this.config.headers);
			}
			if (this.config.url && !model.config.url) {
				model.setConfig('url', this.config.url);
			}
			return model.post();
		}), Promise.resolve());
	}

	parse(data) {
		return extractPhotoList(data).map((record) => normalizePhoto(record));
	}

	destroy() {}
}
